export default class ScrapUtil {
  getTotal (scraps) {
    let total = 100
    let totalScrap = 0
    if (scraps) {
      for (let s of scraps) {
        if (s.value) {
          let val = total * (Number(s.value) / 100)
          totalScrap += val
          total -= val
        }
      }
    }
    return totalScrap
  }
  getUtilization (scraps) {
    return 100 - this.getTotal(scraps)
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/scraputil.js